<div class="card">
    <div class="card-body">
        <h4 class="card-title">Upgrade to Add Automations/Integrations</h4>
        <p class="card-info" *ngIf="isEnabledUpgradeModal">
            <a [href]="bodyTextLink" target="_blank"> {{bodyText}}</a>
        </p>
        <p class="card-info" style="color:#18A0F8;" *ngIf="!isEnabledUpgradeModal"> 
            <a> {{bodyText}}</a>
        </p>
        <div class="card-btn" *ngIf="isEnabledUpgradeModal">
            <button
                class="btn btn-outline-primary"
                type="button"
                (click)="addOn()"
            >
                Add on for $19/mo
            </button>
        </div>
    </div>
</div>
